import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map, switchMap } from 'rxjs';
import { memo } from "../util/index.js";
export function expand(instanceId, api) {
  return memo(instanceId, function (bag) {
    return api.derive.bagsList.listNodes(bag.bag).pipe(map(function (nodes) {
      return _objectSpread(_objectSpread({}, bag), {}, {
        nodes: nodes
      });
    }));
  });
}
export function getExpanded(instanceId, api) {
  return memo(instanceId, function (id) {
    return api.derive.bagsList.get(id).pipe(switchMap(function (bag) {
      return api.derive.bagsList.expand(bag);
    }));
  });
}